
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CKEditor from '../../../../src/components/CKEditor';
import { faInfo, faListOl, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import AddQuestionResource from './AddQuestionResource';
import { useMyContentContext } from '../utils/myContentContext';
import QuestionResources from './QuestionResources';
import PropTypes from 'prop-types';

const CreateQuestion = ({isCRQuestion}) => {
  const [openAttachDocumentModel, setOpenAttachDocumentModel] = useState(false);
  const { question, setQuestion, questionType, setQuestionType, questionDocuments } = useMyContentContext();

  return (
    <>
      <div className='bg-white mb-4 rounded-4 p-4'>
        <>
          {!isCRQuestion && 
          <div className="scoreInfo d-flex mb-4">
            <div className="scoreInfoIcon info-text">
              <span>
                <FontAwesomeIcon icon={faInfo} />
              </span>
            </div>
            <div className="scoreInfoText justify-text">
              <p>
              Type the question here. For Multiple Choice questions, be sure to include the answer choices and use the Numbered List
              tool <FontAwesomeIcon icon={faListOl} /> in the toolbar to set the number choices (don&apos;t type 1., 2., etc. or A., B., etc.).
              For Fill-in questions include ~~1~~ to indicate where an answer box should be displayed.
              </p>
            </div>
          </div>
          }
          <div className='d-flex justify-content-between w-100 mb-3'>
            {!isCRQuestion ?(
              <>
                <div>
                  <h5>Question Type</h5>
                  <div className="d-flex gap-3 mb-4 mt-4">
                    <div className='gap-2 d-flex'>
                      <input
                        type="radio"
                        className="form-check-input cursor-pointer"
                        id="mc"
                        checked={questionType == 1}
                        onChange={() => setQuestionType(1)}
                      />
                      <label className="form-check-label">
     Multiple Choice
                      </label>
                      <OverlayTrigger
                        key="modal-overlay"
                        placement="right"
                        overlay={
                          <Tooltip className="initial-assignment-tooltip">
         For Multiple Choice questions, make sure the answer choices are included with the question because this is what the students will see.<br /><br />In the Answer section of this page, specify the following:
                            <ul><li>Answer - the correct multiple choice answer</li><li>Number of choices - the number of choices that are being presented to the student.</li></ul>
                          </Tooltip>
                        }>
                        <FontAwesomeIcon className="mt-1 clr-fa-circle-question" icon={faQuestionCircle} />
                      </OverlayTrigger>
                    </div>
                    <div className='gap-2 d-flex'>
                      <input
                        type="radio"
                        className="form-check-input cursor-pointer"
                        id="fillin"
                        checked={questionType == 2}
                        onChange={() => setQuestionType(2)}
                      />
                      <label className="form-check-label">
     Fill in
                      </label>
                      <OverlayTrigger
                        key="modal-overlay"
                        placement="right"
                        overlay={
                          <Tooltip className="initial-assignment-tooltip">
         For Fill-In questions, make sure that this string:<br />&nbsp;&nbsp;&nbsp;~~1~~<br /> is included in the question because this is where an input box is displayed when the student views the question.<br /><br />In the Answer section of this page,
         specify the following:<ul><li><br />Answer - the answer to the question. Note that if the answer is a number any equivalent number will be considered to be correct (for example, 2 is the same as 2.0).
           If the answer is text, then case will not matter.</li><li><br />Answer Box Width - specify the maximum number of characters the student can enter. Note that the browser may display a wider edit box than specified.
                            </li><li><br />Answer Box Font Size - controls the size of the answer box. Generally, you should set it to the same size as the text in the question. The default (normal) should be used if you have not set the text size of the question.</li></ul>

                          </Tooltip>
                        }>
                        <FontAwesomeIcon className="mt-1 clr-fa-circle-question" icon={faQuestionCircle} />
                      </OverlayTrigger>
                    </div>
                  </div>
                </div>
              </>
            ):(
              <div></div>
            )}
            <div>
              <button className='btn btn-castleWhite' onClick={() => setOpenAttachDocumentModel(true)}>Attach Document</button>
            </div>
          </div>
        </>
        {questionDocuments.length > 0 &&
        <>
          <QuestionResources/>
          <div className='line'></div>
          <h5 className='mb-3 mt-3 text-center'>Question</h5>
          <div className='line mb-3'></div>
        </>
        }
        <CKEditor
          editorData={question}
          setEditorData={setQuestion}
        />
      </div>
      {openAttachDocumentModel &&
        <AddQuestionResource
          isOpen={openAttachDocumentModel}
          onClose={() => setOpenAttachDocumentModel(false)}
        />
      }
    </>
  );
};

CreateQuestion.propTypes = {
  isCRQuestion: PropTypes.bool,
};

export default CreateQuestion;